import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownArrow = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.6763 5.85946C17.1079 6.33874 17.1079 7.11581 16.6763 7.59509L10.7815 14.1405C10.3499 14.6198 9.65009 14.6198 9.21846 14.1405L3.32372 7.59509C2.89209 7.11581 2.89209 6.33874 3.32372 5.85946C3.75536 5.38018 4.45517 5.38018 4.8868 5.85946L10 11.5371L15.1132 5.85946C15.5448 5.38018 16.2446 5.38018 16.6763 5.85946Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgDownArrow);
export default ForwardRef;
